const downloadBlob = (blob, fileName) => {
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  // Give the browser a moment to start the download before revoking
  setTimeout(() => URL.revokeObjectURL(url), 1000);
};

/**
 * Attaching a file to WhatsApp is only possible through the native share sheet,
 * so try that first. Browsers without file sharing (most desktops) get the PDF
 * downloaded and WhatsApp opened with the message ready to attach it to.
 *
 * Resolves with "shared", "cancelled" or "downloaded".
 */
export async function sharePdfToWhatsApp({ blob, fileName, title, message }) {
  const file = new File([blob], fileName, { type: "application/pdf" });

  if (navigator.share && navigator.canShare && navigator.canShare({ files: [file] })) {
    try {
      await navigator.share({ files: [file], title, text: message });
      return "shared";
    } catch (error) {
      if (error && error.name === "AbortError") {
        return "cancelled";
      }
      // Any other failure falls through to the download route below
    }
  }

  downloadBlob(blob, fileName);
  window.open(`https://wa.me/?text=${encodeURIComponent(message)}`, "_blank", "noopener,noreferrer");
  return "downloaded";
}

export const downloadPdf = (blob, fileName) => downloadBlob(blob, fileName);
